import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash-es';
import { useNavigate } from 'react-router-dom';
import { getUserSelector } from '../../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import { sagaActions } from '../../../../../../../../../sagas/sagaActions';
import DownloadSection from '../../../../../DownloadSection/DownloadSection';
import { getPoSSselector } from '../../../../../../../../../redux/reducers/reducerSlices/POSmartSchedulerReducer';
import '../Tabular/UserRatingsTabular.css'
import CustomDatePickerMMYYYYonly from '../../../../../../../DatePicker/Month/CustomDatePickerMMYYYYonly';
import CommonChart from '../../../../../Dashboard/DefaultDashboard/Graphs/CommonChart';
import NoData from '../../../../../Dashboard/DefaultDashboard/DrillDownReports/Common/Nodata';
import { createChartsProps, donutType } from '../../../../../../../../Assests/DashboardUtility';
import { userRatingColumnGraph } from '../../../../../../../../Assests/GraphUtilities';
import moment from 'moment';
import { AppConstant } from '../../../../../../../../Assests/AppConstant';
import Loader from '../../../../../../../Loader/Loader';
import CustomDropDown from '../../../../../../../Common/CustomDropDown/CustomDropDown';
import { getWarehouseDataReducer } from "../../../../../../../../../redux/reducers/reducerSlices/GetWarehouseDataReducer";

const UserRatingsGraphical = (props) => {
    const { themeSelected = 'light-mode', view, startDate, setStartDate, endDate, setEndDate, handleStartYearChange, handleEndYearChange, handleStartDateChange, handleEndDateChange, isError, handleWarehouseChange } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pOSS = useSelector(getPoSSselector);
    const { userRatingsAllData } = pOSS;
    const userObj = useSelector(getUserSelector);
    const { userType } = userObj;
    const [currentTable, setCurrentTable] = useState(null);
    // moment.tz.setDefault(selectedWarehouse?.TimeZone);
    const [isLoading, setIsLoading] = useState(true);
    const [showGraph, setShowGraph] = useState(false)
    const [userRatingsColumnData, setUserRatingsColumnData] = useState({})
    const [currentWarehouseFilterSelected, setCurrentWarehouseFilterSelected] = useState({ WarehouseName: 'All' });
    const warehouseData = useSelector(getWarehouseDataReducer);
    const [warehouseListData, setWarehouseListData] = useState([]);
    
    /**
     * used to dispatch actions to reset the user rating details
     */
    useEffect(() => {
        dispatch({ type: sagaActions.RESET_USER_RATINGS_ACTION });
        setIsLoading(false);
        setShowGraph(false)
        return () => {
            dispatch({ type: sagaActions.RESET_USER_RATINGS_ACTION });
        }
    }, [])

     useEffect(() => {
            setCurrentWarehouseFilterSelected(currentWarehouseFilterSelected)
            handleWarehouseChange(currentWarehouseFilterSelected)
        }, [currentWarehouseFilterSelected])
    
    useEffect(() => {
            if (warehouseData?.data) {
                // 1. Filter out empty names
                let filteredList = warehouseData.data.filter(
                    w => w?.WarehouseName && w.WarehouseName.trim() !== ""
                );
    
                // 2. Remove duplicates by WarehouseName
                filteredList = _.uniqBy(filteredList, 'WarehouseName');
    
                // 3. Sort alphabetically by WarehouseName
                filteredList = filteredList.sort((a, b) =>
                    a.WarehouseName.localeCompare(b.WarehouseName)
                );
    
                // 4. Add "All" option at the start
                const allOption = { ID: null, WarehouseName: 'All' };
                const finalList = [allOption, ...filteredList];
    
                // 4. Set list and default selection
                setWarehouseListData(finalList);
                // 👉 only set default once if nothing is selected yet
                if (!currentWarehouseFilterSelected?.WarehouseName) {
                    setCurrentWarehouseFilterSelected(allOption);
                }
            }
        }, [warehouseData]);
    
    

    /**
     * validates and fetch user rating details
     */
    useEffect(() => {
        if (!isError && startDate && endDate && currentWarehouseFilterSelected) {
            fetchUserRatings()
        }
    }, [startDate, endDate, isError, currentWarehouseFilterSelected])

    /**
     * Used to validate user ratings details and showa graph
     */
    useEffect(() => {
        if (!_.isEmpty(userRatingsColumnData)) {
            setIsLoading(false)
            setShowGraph(true)
        } else {
            setShowGraph(false)
        }
    }, [userRatingsColumnData])

    /**
     * Used if user rating data is returned successfuly then it will populate or else return error message
     */
    useEffect(() => {
        if (_.upperCase(userRatingsAllData?.status) === 'SUCCESS') {
            setIsLoading(false)
            setShowGraph(false)
            if (!_.isEmpty(userRatingsAllData?.data) && _.size(userRatingsAllData?.data?.counts)) {
                let dataGreat = [];
                let dataGood = [];
                let dataOkay = [];
                const categories = []

                Array.from(userRatingsAllData?.data?.counts).forEach(el => {
                    categories.push(el.monthName);
                    dataGreat.push(Math.round(el.percentages.Great));
                    dataGood.push(Math.round(el.percentages.Good));
                    dataOkay.push(Math.round(el.percentages.Okay));

                })
                const series = [{ name: 'Great', data: dataGreat }, { name: 'Good', data: dataGood }, { name: 'Okay', data: dataOkay }]
                const userRatingsGraphPayload = createChartsProps({ series: series, categories: categories }, donutType.userRatingsColumnGraph, themeSelected, userRatingColumnGraph)
                setUserRatingsColumnData({ ...userRatingsGraphPayload })
            }
        } else if (_.upperCase(userRatingsAllData?.status) === 'FAIL') {
            setIsLoading(false)
            setShowGraph(false)
            dispatch({ type: sagaActions.RESET_USER_RATINGS_ACTION });
        }
        else {

            setShowGraph(false)
        }

    }, [userRatingsAllData])


    /**
     * This function used to get the user rating details by connecting with API
     */
    const fetchUserRatings = () => {
        if (userType === 'USER') {
            setIsLoading(true);
            const eDate = moment(endDate).hours(23).minutes(59).seconds(59)
            const params = {
                "startDate": moment(startDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "endDate": moment(eDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "currentPage": 1,
                "itemsPerPage": userRatingsAllData?.data?.itemsPerPage || 100,
                "rating": null,
                "type": view,
                "IDWarehouse": currentWarehouseFilterSelected?.WarehouseName === 'All' ? null : currentWarehouseFilterSelected.ID
            }
            dispatch({ type: sagaActions.UPDATE_USER_RATINGS, payload: params });
        } else if (userType === 'SUPERADMIN') {
            setIsLoading(true);
            const eDate = moment(endDate).hours(23).minutes(59).seconds(59)
            const params = {
                "startDate": moment(startDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "endDate": moment(eDate).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "currentPage": 1,
                "itemsPerPage": userRatingsAllData?.data?.itemsPerPage || 100,
                "rating": null,
                "type": view,
                "IDWarehouse": currentWarehouseFilterSelected?.WarehouseName === 'All' ? null : currentWarehouseFilterSelected.ID
            }
            dispatch({ type: sagaActions.UPDATE_USER_RATINGS, payload: params });
        } else {
            // console.log(userType, " 🚀: This report is not accessible")
        }
    }

    /**
     * This function is used to display loader
     * @param {*} themeSelected 
     * @param {*} height 
     * @param {*} count 
     * @returns 
     */
    const displayLoader = (themeSelected, height, count) => {
        return (
            <>
                <div className='navText d-flex justify-content-center color-highlight'>
                    {AppConstant.reports.userRatings.graphLoaderText}
                </div>
                <Loader height={200} count={count || 1} highlightColor={themeSelected === 'dark-mode' ? '#151515' : ''}
                    baseColor={themeSelected === 'dark-mode' ? '#575757'
                        : ''}
                />
            </>
        )
    }
   const showWarehouseListDropDownForFilters = () => {
    return (
        <div className='d-flex align-items-center'>
            <div className='me-2 titleFiltersLeaveMeta'>{AppConstant.commonStrings.selectWarehouse} </div>
            <CustomDropDown
                themeSelected={themeSelected}
                data={warehouseListData}
                placeHolder={currentWarehouseFilterSelected?.WarehouseName}
                onSelect={(event) => setCurrentWarehouseFilterSelected(event)}
                keyStr={'WarehouseName'}
            />
        </div>
    )
}

    return (
        <div>
            <div className='d-flex justify-content-between my-2 mx-3'>
                <div className='fw-bold'>{'User Ratings'}</div>
                <div className='d-flex justify-content-end align-items-end gap-2'>
                    <CustomDatePickerMMYYYYonly wrapperClassName='mx-2' date={startDate} setDate={setStartDate} maxDate={new Date()} handleCalendarChange={(d) => {
                        setShowGraph(false)
                        setIsLoading(false);
                        handleStartYearChange(d)
                    }} label='Start Date' themeSelected={themeSelected}
                        onChangeHandler={(d) => {
                            setIsLoading(false);
                            handleStartDateChange(d)
                        }}
                    />
                    <CustomDatePickerMMYYYYonly wrapperClassName='' date={endDate} setDate={setEndDate} handleCalendarChange={(d) => {
                        setIsLoading(false);
                        setShowGraph(false)
                        handleEndYearChange(d)
                    }} label='End Date' maxDate={new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)} themeSelected={themeSelected} onChangeHandler={(d) => {
                        setIsLoading(false);
                        handleEndDateChange(d)
                    }} />
                    <div className='ms-2 w-100'>
                        {
                            showWarehouseListDropDownForFilters()
                        }
                    </div>
                    <div className='d-flex justify-content-end align-items-center'>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-center m-4'>
                {
                    !isLoading ?
                        showGraph ?
                            <div id='bar-chart'><div className="responsive-chart-bar"> <CommonChart data={userRatingsColumnData} /> </div></div>
                            : <NoData themeSelected={themeSelected} />
                        : <div className='w-50'>{displayLoader(themeSelected)}</div>

                }
            </div>
        </div>
    );
}

export default UserRatingsGraphical;